import {
  Box3,
  Camera,
  Object3D,
  PerspectiveCamera,
  Sphere,
  Vector3,
} from "three";
import { CAMERA_FAR, CAMERA_NEAR } from "./camera/CameraConstants";
import type { CameraInterface } from "./CameraTypes";

export class BasicCamera implements CameraInterface {
  private _camera?: PerspectiveCamera;
  private _width?: number;
  private _height?: number;

  constructor(width?: number, height?: number) {
    this._width = width;
    this._height = height;
    if (!this._width) this._width = window.innerWidth;
    if (!this._height) this._height = window.innerHeight;
    this._camera = new PerspectiveCamera(
      25,
      this._width / this._height,
      CAMERA_NEAR,
      CAMERA_FAR,
    );
    this._camera.updateProjectionMatrix();
  }

  addEventListener(_name: string, _func: (event: any) => void): void {
    throw new Error("Method not implemented.");
  }

  removeEventListener(_name: string, _func: (event: any) => void): void {
    throw new Error("Method not implemented.");
  }

  fit(object: Object3D | { center: Vector3; radius: number }) {
    let center = new Vector3();
    let radius = 1;
    if (object instanceof Object3D) {
      const box = new Box3().setFromObject(object, true);
      const sphere = box.getBoundingSphere(new Sphere());
      center = sphere.center;
      radius = sphere.radius;
    } else {
      center = object.center;
      radius = object.radius;
    }

    const fov = this._camera!.fov * (Math.PI / 180) * 1.0;
    const distance = radius / Math.sin(fov * 0.5);

    const difvector = this._camera!.position.clone()
      .sub(center)
      .normalize()
      .multiplyScalar(distance);

    const newPosition = center.clone().add(difvector);

    this._camera?.position.copy(newPosition);
    this._camera?.lookAt(center);
    this._camera?.updateProjectionMatrix();
    return { position: newPosition, target: center };
  }

  get instance(): Camera {
    return this._camera!;
  }

  get controller() {
    return null;
  }

  update(width?: number, height?: number): void {
    if (width) this._width = width;
    if (height) this._height = height;
    this._camera!.aspect = this._width! / this._height!;
    this._camera?.updateProjectionMatrix();
  }

  unproject(_point: Vector3): void {}
}
